// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Or","showButton":"e_Pr","showButtonIcon":"e_Qr","viafouraShareBar":"e_Rr","viafouraShareBarVisible":"e_Sr"};